
import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { FileSpreadsheet, BarChart, Filter, FileText } from 'lucide-react';

const TemplatesTab: React.FC = () => {
  return (
    <div className="grid grid-cols-2 gap-4">
      <Card className="border border-gray-800 bg-[#0A1428] hover:bg-[#0F1A30] transition-all cursor-pointer">
        <CardContent className="p-4 flex items-center">
          <div className="rounded-full bg-blue-500/10 p-2 mr-3">
            <FileSpreadsheet className="h-5 w-5 text-blue-400" />
          </div>
          <div>
            <h4 className="text-sm font-medium text-white">Usage by Facility</h4>
            <p className="text-xs text-gray-400">Compare energy use across locations</p>
          </div>
        </CardContent>
      </Card>
      
      <Card className="border border-gray-800 bg-[#0A1428] hover:bg-[#0F1A30] transition-all cursor-pointer">
        <CardContent className="p-4 flex items-center">
          <div className="rounded-full bg-blue-500/10 p-2 mr-3">
            <BarChart className="h-5 w-5 text-blue-400" />
          </div>
          <div>
            <h4 className="text-sm font-medium text-white">Cost Trends</h4>
            <p className="text-xs text-gray-400">Analyze spending patterns</p>
          </div>
        </CardContent>
      </Card>
      
      <Card className="border border-gray-800 bg-[#0A1428] hover:bg-[#0F1A30] transition-all cursor-pointer">
        <CardContent className="p-4 flex items-center">
          <div className="rounded-full bg-blue-500/10 p-2 mr-3">
            <Filter className="h-5 w-5 text-blue-400" />
          </div>
          <div>
            <h4 className="text-sm font-medium text-white">Rebate Eligibility</h4>
            <p className="text-xs text-gray-400">Identify rebate opportunities</p>
          </div>
        </CardContent>
      </Card>
      
      <Card className="border border-gray-800 bg-[#0A1428] hover:bg-[#0F1A30] transition-all cursor-pointer">
        <CardContent className="p-4 flex items-center">
          <div className="rounded-full bg-blue-500/10 p-2 mr-3">
            <FileText className="h-5 w-5 text-blue-400" />
          </div>
          <div>
            <h4 className="text-sm font-medium text-white">Custom Report</h4>
            <p className="text-xs text-gray-400">Build your own report</p>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default TemplatesTab;
